module.exports = "<nvd3 [options]=\"_graphStatsOptions\" [data]=\"_graphStats\">\n</nvd3>\n"